import { StyledWrapper } from './styles';

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
	id: string;
	checked?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
}

const Switch = ({ id, checked, onChange, disabled, ...rest }: SwitchProps) => {
	return (
		<StyledWrapper>
			<div className="checkbox-apple">
				<input
					className="yep"
					id={id}
					type="checkbox"
					checked={checked}
					onChange={onChange}
					disabled={disabled}
					{...rest}
				/>
				<label htmlFor={id} />
			</div>
		</StyledWrapper>
	);
};

export { Switch };
